const myHost = "https://uptight-coat-boa.cyclic.app/";
export default myHost;
